export default __webpack_public_path__ + "static/media/higher_icon_chat.3f747e68.svg";